module.exports = __webpack_public_path__ + "static/media/f9e17202.jpg";